// 获取当前日期时间
const getCurrentTime = function () {
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hour = date.getHours();
    let minute = date.getMinutes();
    let second = date.getSeconds();
    if (hour > 12) {
        hour -= 12;
    }
    month = check(month);
    day = check(day);
    hour = check(hour);
    minute = check(minute);
    second = check(second);
    function check(i) {
        let num = i < 10 ? "0" + i : i;
        return num;
    }

    let currentTime = {
        date: year + "年" + month + "月" + day + "日",
        time: hour + ":" + minute + ":" + second
    }

    return currentTime
}

export {
    getCurrentTime
}